import React, { useState } from "react";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import Cookies from "js-cookie";
import { Table, TableContainer } from "../styles";
import UserSelect from "../UserSelect";
import RowCount from "../RowCount";
import MiscJsonCell from "../MiscJsonCell";
import {
  fetchFeedOwnerRows,
  FeedOwnerRow
} from "../../../actions/feedOwnerReport";

type Props = {
  users: string[];
  rows: FeedOwnerRow[];
  selectedUser: string | null;
  fetchRows: (token: string, user: string) => void;
};

function FeedOwnerSimple({ users, rows, selectedUser, fetchRows }: Props) {
  const [picked, setPicked] = useState<string | null>(selectedUser);

  const onPick = (user: string) => {
    setPicked(user);
    const token = Cookies.get("accessToken") || "";
    fetchRows(token, user);
  };

  const columns = rows[0] ? Object.keys(rows[0]) : [];

  return (
    <>
      <UserSelect users={users} selected={picked} onSelect={onPick} />
      {!picked && <p style={{ color: "#6b7280" }}>Pick a user to see their reports.</p>}
      {picked && (
        picked !== selectedUser
          ? <p style={{ color: "#6b7280" }}>Loading…</p>
          : rows.length === 0
            ? <p style={{ color: "#6b7280" }}>No reports for {picked}.</p>
            : (
              <>
                <TableContainer>
                  <Table>
                    <thead>
                      <tr>{columns.map(c => <th key={c}>{c}</th>)}</tr>
                    </thead>
                    <tbody>
                      {rows.map((row, i) => (
                        <tr key={i}>
                          {columns.map(c => (
                            <td key={c}>
                              {row[c] == null
                                ? ""
                                : typeof row[c] === "object"
                                  ? <MiscJsonCell value={row[c]} />
                                  : String(row[c])}
                            </td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </TableContainer>
                <RowCount count={rows.length} user={picked} />
              </>
            )
      )}
    </>
  );
}

const mapStateToProps = (state: any) => ({
  users: state.entities.feedOwnerReport.users,
  rows: state.entities.feedOwnerReport.rows,
  selectedUser: state.entities.feedOwnerReport.selectedUser
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  fetchRows: (token: string, user: string) =>
    fetchFeedOwnerRows(token, user)(dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(FeedOwnerSimple);
